import styles from '@convelio/stylio/styles.module.scss';
import { extractFromPixel } from 'src/utils/helpers/StylioHelper';

export default {
  borderRadius: extractFromPixel(styles.cvoBorderRadius)
};
